import React from 'react';
import { FormControlLabel, TextField, InputAdornment, ThemeOptions } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { fieldTypes } from '@/helpers/constants';
import useWarningField from '@/hooks/useWarningField';
import useCampaignSearchSelected from '@/hooks/useCampaignSearchSelected';
import MandatoryLabel from '@/components/UI/MandatoryLabel/MandatoryLabel';
import HighlightMask from '@/components//HighlightMask/HighlightMask';

interface InputTextRatePctProps {
  disabled?: boolean;
  id: string;
  label: string;
  formControlClass?: string;
  handleChange?: (ev: React.ChangeEvent<HTMLInputElement>) => void; // eslint-disable-line no-unused-vars
  isMandatory?: boolean;
  value: string;
  maxLength: number;
  multiline?: boolean;
  rows?: number;
  onClick?: () => void;
  onBlur?: () => void;
  type?: string;
  placeholder?: string;
  invalid?: boolean;
  otherConditionInvalid?: boolean;
  fieldPath?: string[];
}

const InputTextRatePct: React.FC<InputTextRatePctProps> = (props) => {
  const { disabled, id, label, formControlClass, handleChange = () => { }, isMandatory = false, value, maxLength,
    multiline, rows, onClick = () => null, onBlur = () => null, type, placeholder, invalid, otherConditionInvalid, fieldPath,
  } = props;
  const inputLabel = isMandatory ? (<>{label} <MandatoryLabel /></>) : label;

  const warning = useWarningField(fieldPath, fieldTypes.INPUT_NUMBER, otherConditionInvalid) || invalid;
  const { campaignSearchSelected } = useCampaignSearchSelected(fieldPath, fieldTypes.INPUT_NUMBER, true);

  const useStyles = makeStyles(({ cartTheme }: ThemeOptions) => ({
    placeholderFont: {
      '& input::placeholder': {
        fontSize: '10px',
      },
      '& .MuiInputBase-root': warning ? {
        backgroundColor: cartTheme.alertWarningBg,
      } : {},
    },
  }));

  const classes = useStyles();

  return (
    <FormControlLabel
      className={`${formControlClass} ${warning ? 'ValidationIndicatorField' : ''}`}
      classes={{ root: classes.placeholderFont }}
      label={undefined}
      control={(
        <HighlightMask
          fieldId={id}
          fieldPath={fieldPath}
          value={value}
          fieldSelected={campaignSearchSelected}
          fieldType={fieldTypes.INPUT_NUMBER}
          disabled={disabled}
          noTranslationField
        >
          <TextField
            variant="outlined"
            multiline={multiline}
            minRows={rows}
            InputProps={{
              componentsProps: { input: { maxLength } },
              endAdornment: (<InputAdornment position="end">%</InputAdornment>),
            }}
            InputLabelProps={{
              shrink: true,
            }}
            disabled={disabled}
            id={id}
            {...(type ? { type } : {})}
            {...(placeholder ? { placeholder } : {})}
            label={inputLabel}
            onChange={handleChange}
            onBlur={onBlur}
            onClick={!disabled ? onClick : undefined}
            value={value}
            fullWidth
            error={warning}
          />
        </HighlightMask>
      )}
    />
  );
};

export default InputTextRatePct;
